/**
 * @generated SignedSource<<90a301b48628f89c4216af8ea5c0e42e>>
 * @relayHash 54bc6313ef4580fd0d1d858b0cd8904a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0365bc3be859c7e67a127713b625b50dc916f847d76a49601135535ae8e80f4c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useQueryInvitationUrlQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  orgId: string;
};
export type useQueryInvitationUrlQuery$data = {
  readonly admin_accessUrls: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expirationDate: string | null | undefined;
        readonly id: string;
        readonly resourceUrl: string | null | undefined;
        readonly status: string;
        readonly url: string;
      };
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type useQueryInvitationUrlQuery = {
  response: useQueryInvitationUrlQuery$data;
  variables: useQueryInvitationUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      }
    ],
    "concreteType": "AdminAccessUrlConnection",
    "kind": "LinkedField",
    "name": "admin_accessUrls",
    "plural": false,
    "selections": [
      {
        "concreteType": "AdminAccessUrlEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "AdminAccessUrlV2",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "resourceUrl"
              },
              {
                "kind": "ScalarField",
                "name": "expirationDate"
              },
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "startCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useQueryInvitationUrlQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useQueryInvitationUrlQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "54bc6313ef4580fd0d1d858b0cd8904a",
    "id": "0365bc3be859c7e67a127713b625b50dc916f847d76a49601135535ae8e80f4c",
    "metadata": {},
    "name": "useQueryInvitationUrlQuery",
    "operationKind": "query",
    "text": "query useQueryInvitationUrlQuery($orgId:ID!,$after:String,$first:Int){admin_accessUrls(orgId:$orgId,after:$after,first:$first){edges{node{id,resourceUrl,expirationDate,url,status}},pageInfo{endCursor,hasNextPage,startCursor}}}"
  }
};
})();

(node as any).hash = "c341c045655f91003362243763c690c2";

export default node;
